export const CONTACT_TRIGGER = 'contact_seller';
